import axiosInstance from '../axiosInstance';
import { requestResources } from '../requestResources';
import { IUserData } from './types';
import { IResponse } from '../types';

export const getUserData = (): IResponse<IUserData> =>
  axiosInstance.get(`${requestResources.clientPortalAuth}`);

export default {};
